class Menu {
	constructor(obj) {
		this.holder = obj;
		this.items = document.querySelectorAll('*[data-name]');

		document.addEventListener('scroll', this.test.bind(this));
		document.addEventListener('resize', this.test.bind(this));
		this.test();

		document.querySelectorAll('.js-scroll-to').forEach(item => {
			item.addEventListener('click', (e) => {
				this.scrollTo(e.currentTarget.getAttribute('href').replace(/^.*#/, ''));
			});
		});
		
		if (document.location.hash) {
			this.scrollTo(document.location.hash.replace(/^.*#/, ''));
		}
	}

	scrollTo(name) {
		let yOffset = 100;
		let element = document.querySelector('[data-name="' + name + '"]');
		console.log('[data-name="' + name + '"]');
		if (element) {
			let y = element.getBoundingClientRect().top + window.pageYOffset - yOffset;
			window.scrollTo({top: y, behavior: 'smooth'});
		}
	}

	test() {
		for (let i = 0; i < this.items.length; i++) {
			let item = this.items[i];
			let rect = item.getBoundingClientRect();
			if (
				rect.top < window.innerHeight * .6 &&
				rect.top + (rect.bottom - rect.top) * .6 > 0
			) {
				this.setCurrent(item.getAttribute('data-name'));
			} else {
				this.unsetCurrent(item.getAttribute('data-name'));
			}
		}
	}

	setCurrent(name) {
		this.unsetCurrent();

		let link = this.holder.querySelector('.menu-item[href$="#' + name + '"]');
		if (link) {
			link.classList.add('menu-item_current');
		}
	}

	unsetCurrent(name) {
		let current = this.holder.querySelector(name ? '.menu-item[href$="#' + name + '"]' : '.menu-item_current');
		if (current) {
			current.classList.remove('menu-item_current');
		}
	}
}

window.addEventListener('load', () => {
	if ($('.page.main').length) {
		new Menu(document.querySelector('.menu'));
	}
});